import { Component, OnInit } from '@angular/core';
import { jsPDF } from 'jspdf';
import domtoimage from 'dom-to-image';
import { ModalController } from '@ionic/angular';
import { RegistrationModerationDocumentAuditTrailModel } from 'src/app/model/RegistrationModerationDocumentAuditTrailModel';

@Component({
  selector: 'app-secure-moderation-audit-trail',
  templateUrl: './moderation-audit-trail.component.html',
  styleUrls: ['./moderation-audit-trail.component.scss']
})
export class ModerationAuditTrailComponent implements OnInit {
  moderationAuditTrail: RegistrationModerationDocumentAuditTrailModel;
  
  constructor(private modalCtrl: ModalController) { }

  ngOnInit(): void { }

  onCancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  downloadPdf() {
    const pdfBlock = document.getElementById("print-wrapper");
    const options = { 
      background: "white", 
      height: pdfBlock.clientHeight, 
      width: pdfBlock.clientWidth,
      quality: 1.5 
    };
    console.log(pdfBlock.clientWidth, pdfBlock.clientHeight);

    domtoimage.toPng(pdfBlock, options).then((imgData) => {
      const doc = new jsPDF('p', 'px', [options.width, options.height]);
      const imgProps = doc.getImageProperties(imgData);
      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      console.log('-----', pdfWidth, pdfHeight);

      doc.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      doc.save('ModerationAuditTrail('+this.moderationAuditTrail.applicantName+').pdf');
    });
  }
}
